import SocialBar from './SocialBar';

export default function() {
    let bars = document.querySelectorAll('[data-social-bar]:not([data-social-bar-loadstate])');
    if (bars.length > 0) {
        for (let i = 0, bLen = bars.length; i < bLen; i++) {
            new SocialBar(bars[i]);
        }
    }
};


// WEBPACK FOOTER //
// ./assets/components/SocialBar/SocialBarLoader.js